import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { $locale } from '../i18n/model/main'

/**
 * Convert a value into a header value, or omit the header when it is not set
 */
export function header(
  value: string | number | null | undefined
): string | null {
  return value == null || value === '' ? null : String(value)
}

/** ISO 639-1 two-letter code for `mw-language` (NF-173.*) */
export function normalizeMwLanguage(
  locale: string | null | undefined
): string | null {
  const trimmed = locale?.trim()
  const code = trimmed?.split(/[-_]/)[0]?.toLowerCase()
  if (!code || !/^[a-z]{2}$/.test(code)) {
    return null
  }
  return code
}

export const $mwPid: Store<string | null> = api.session.$session.map(
  (session) => header(session?.providerId)
)

export const $mwPackageId: Store<string | null> = api.session.$session.map(
  (session) => header(session?.packageId)
)

export const $mwLanguage: Store<string | null> =
  $locale.map(normalizeMwLanguage)

/**
 * Remote-config defaults use `tria_organizationId: 0` as an empty sentinel.
 * The previous client omitted `multiorg-Id` unless the id was truthy.
 */
export function organizationIdHeader(
  id: number | null | undefined
): string | null {
  return header(id || null)
}
